import React, { useMemo, useState } from 'react';

const TablePicker = ({ tables, value, onChange }) => {
  const [query, setQuery] = useState('');

  const grouped = useMemo(() => {
    const q = query.trim().toLowerCase();
    const m = {};
    for (const t of tables) {
      const schema = t.schema || t.schema_name;
      if (q) {
        const isSelected = value && value.schema === schema && value.name === t.name;
        const hay = `${schema}.${t.name}`.toLowerCase();
        if (!hay.includes(q) && !isSelected) continue;
      }
      if (!m[schema]) m[schema] = [];
      m[schema].push(t);
    }
    return m;
  }, [tables, query, value]);

  const matchCount = useMemo(
    () => Object.values(grouped).reduce((n, arr) => n + arr.length, 0),
    [grouped],
  );

  const current = value ? `${value.schema}.${value.name}` : '';

  const handleChange = (e) => {
    const v = e.target.value;
    if (!v) {
      onChange(null);
      return;
    }
    const [schema, ...rest] = v.split('.');
    const name = rest.join('.');
    onChange({ schema, name });
  };

  return (
    <div className="db-explorer-picker">
      <input
        type="text"
        className="form-control form-control-sm db-explorer-table-search"
        placeholder="Search tables…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <select
        className="form-select form-select-sm db-explorer-table-picker"
        value={current}
        onChange={handleChange}
      >
        <option value="">
          {query ? `— ${matchCount} match${matchCount === 1 ? '' : 'es'} —` : '— select a table —'}
        </option>
        {Object.keys(grouped).sort().map((schema) => (
          <optgroup key={schema} label={schema}>
            {grouped[schema].map((t) => (
              <option key={`${schema}.${t.name}`} value={`${schema}.${t.name}`}>
                {t.name}{t.is_view ? ' (view)' : ''}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
};

export default TablePicker;
